import theme from '../../muiTheme';

const styles = {

    closeButton: {
        margin: '0px',
        padding: '10px 10px',
        minWidth: '10px',
        maxWidth: '60px',
        marginRight: '5px',
        // border: '0px solid transparent',
        // background: 'transparent',
        //marginLeft: '-30px',
        
        [theme.breakpoints.down('sm')]: {
            padding: '15px 15px',
            minWidth: '10px',
        }
    }

}

export default styles; 